<template>
  <nav>
    <!-- <span @click="increment">Home</span> -->
  </nav>
  <router-view/>
</template>
<script>
import router from '@/router';
export default {
  setup() { 
    const increment = () => {
      router.push('about')
    };
    return {
      increment
    };
  }
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
